import script from "./CheckMark.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckMark.vue?vue&type=script&lang=ts&setup=true"

import "./CheckMark.vue?vue&type=style&index=0&id=6cb2d40c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb2d40c"]])

export default __exports__